import React from 'react';
import { Link } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { OMR_RATING_IMAGE_SRC, OMR_REVIEWS_URL } from './constants';

export const OmrRatingWidget = () => (
    <Link href={OMR_REVIEWS_URL} target="_blank" rel="noreferrer" title="fiverr" decoration="none">
        <Image
            src={OMR_RATING_IMAGE_SRC}
            alt="OMR - Rating Widget"
            display="block"
            width="auto"
            height={{
                default: '110px',
                lg: '130px',
            }}
        />
    </Link>
);
